import sensors from '@/plugins/sensors.js';
let eventNameObj = {
	click: 'h5_clk',
	input: 'h5_input',
	imp: 'h5_element_imp',
	auth: 'h5_auth',
	banner: 'h5_banner_clk'
};
const SA = {
	disposeParam: function(data) {
		// 处理数据
		let obj = {};
		const keys = Object.keys(data);
		keys.forEach(key => {
			let isNum = key.match(/^num[0-9]*$/);
			let isDate = key.match(/^date[0-9]*$/);
			if (data[key] == null) {
				delete obj[key];
			} else if (key === 'bizId' || key === 'bizid') {
				obj['bizId'] = data[key];
			} else if (isNum) {
				let numval = String(data[key])
					// eslint-disable-next-line no-useless-escape
					.replace(/[\%￥\a-zA-Z"]/g, '')
					.match(/\d*(\.\d+)?/)[0];
				obj[key] = numval === '' ? null : Number(numval);
			} else if (isDate) {
				obj[key] = data[key];
			} else {
				obj[key] = String(data[key]);
			}
		});
		return obj;
	},
	h5_clk: function(data) {
		let obj = this.disposeParam(data);
		sensors.track(eventNameObj.click, obj);
	},
	h5_input: function(data) {
		let obj = this.disposeParam(data);
		sensors.track(eventNameObj.input, obj);
	},
	h5_element_imp: function(data) {
		let obj = this.disposeParam(data);
		sensors.track(eventNameObj.imp, obj);
	},
	h5_auth: function(data) {
		let obj = this.disposeParam(data);
		sensors.track(eventNameObj.auth, obj);
	},
	h5_banner_clk: function(data) {
		let obj = this.disposeParam(data);
		sensors.track(eventNameObj.banner, obj);
	}
};

const POINT = function(key, param) {
	try {
		SA[key](param);
	} catch (e) {
		console.error(e);
	}
};
export default POINT;
